import axios from 'axios'
import { config } from '../Config/config'


const locationLevelService = {
    
    getAll: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/locationLevelFilter', filter)
            // const result = axios.get(config.apiUrl + '/locationLevel')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllData: () => {
        // getAll: () => {
        const result = axios.get(config.apiUrl + '/locationLevel')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/locationLevel', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editData: (data) => {
        const result = axios.put(config.apiUrl + '/locationLevel', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editDataDelete: (data) => {
        const result = axios.put(config.apiUrl + '/locationLevelDelete', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/locationLevelById/' + id)
            //(+ id) => memanggil parameter
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    // getByCategoryId: (id) => {
    //     const result = axios.get(config.apiUrl + '/customerRelationByCategoryId/' + id)

    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // deleteData
    deleteData: (id) => {
        // deleteData: (data) => {
        const result = axios.delete(config.apiUrl + '/locationLevel/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default locationLevelService
